/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Empreendimento {
  constructor () {


    this.empreendimento_id = uuidV4()
    this.nome = ''
    this.logrado = ''
    this.complemento = ''
    this.bairro = ''
    this.municipio_id = ''
  }
}
